import styled from "styled-components";

export const StyledContainer = styled.div`
    position: absolute;
    bottom: 2rem;
    left: 2rem;
    width: 9rem;
`;
